module.exports = __webpack_public_path__ + "b10676142ff77fcc05ad78b799c822aa.png";